module.exports = __webpack_public_path__ + "img/p_sz_10.d774a69c.svg";